import * as yup from 'yup'
import { UserSecurityQuestionsEnum } from './enums/UserSecurityQuestionsEnum'
import { get } from 'lodash'

/**
 * Predefined questions
 *
 * What is your mother's maiden name?
 * What was your childhood nickname?
 * What is your oldest sibling's middle name?
 * In what city or town was your first job?
 * What was your dream job as a child?
 * What is your grandmother's first name?
 * What is your favourite movie?
 * What is your favourite pet's name?
 * What is the first phone model you owned?
 * What is your favourite pizza topping?
 */

export const MAX_SECURITY_QUESTIONS_PER_USER = 3
export const MIN_USER_SECURITY_QUESTION_ANSWER_LEN = 3
export const MAX_USER_SECURITY_QUESTION_ANSWER_LEN = 64

export const userSecurityQuestionsValidationSchema = yup
  .object()
  .shape({
    question: yup
      .string()
      .oneOf(Object.values(UserSecurityQuestionsEnum), 'Unknown question'),
    answer: yup
      .string()
      .required('Security answer can not be empty')
      .min(MIN_USER_SECURITY_QUESTION_ANSWER_LEN, `Insert min 3 characters`)
      .max(MAX_USER_SECURITY_QUESTION_ANSWER_LEN, `Insert max 64 characters`)
  })
  .noUnknown(true, 'Input has unknown keys ${unknown}')

export const userSecurityQuestionsValidationSchemaFormik = yup
  .array()
  .of(userSecurityQuestionsValidationSchema)
  .min(MAX_SECURITY_QUESTIONS_PER_USER)
  .max(MAX_SECURITY_QUESTIONS_PER_USER)
  .test('unique', 'Selected questions need te be unique.', function (list) {
    if (!list) {
      return false
    }
    const mapper = (x) => get(x, 'question')
    const set = [...new Set(list.map(mapper))]
    const isUnique = list.length === set.length
    if (isUnique) {
      return true
    }

    const idx = list.findIndex((l, i) => mapper(l) !== set[i])
    return this.createError({
      path: `[${idx}].question`,
      // we dont show this in UI, translation is no needed (not possible)
      message: 'Selected questions need te be unique.'
    })
  })
